// Single source of truth for what gates the Digital ordering report.
//
// Two places decide whether this report is reachable: the nav entry in
// components/Navbar/Experiences/Content.tsx and the page itself. They must
// agree — if they drift, the user either sees a nav link that redirects to /
// the moment they click it, or loses the link while the route still renders
// for anyone who navigates by URL.
//
// They used to agree only by convention: each file hardcoded its own copy of
// the flag key and the permission config, with a comment in each saying the
// other "must mirror" it. Nothing enforced that, and because both test suites
// mock their own inputs independently, a rename in one file would have left
// both suites green. Importing the same constants makes the drift impossible
// rather than merely discouraged.
export const DIGITAL_ORDERING_FLAG = 'mx-promote-insights-lab-reports'

export const DIGITAL_ORDERING_PERMISSION = {
  rbac: 'Reports',
  legacy: 'LocationReports',
}
